import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, TextField, MenuItem, Button, Alert, Grid } from '@mui/material';
import { superAdminApi, SubscriptionPlan } from '../../services/superAdminApi';

export const SATenantCreate: React.FC = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', subdomain: '', plan: 'Starter', subscriptionPlanId: undefined as number | undefined, adminName: 'Admin', adminEmail: '', adminPassword: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [plans, setPlans] = useState<SubscriptionPlan[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const resp = await superAdminApi.listPlans();
        const list = resp.data || [];
        setPlans(list);
        if (list.length && !form.subscriptionPlanId) {
          setForm((prev) => ({ ...prev, subscriptionPlanId: list[0].id, plan: list[0].name }));
        }
      } catch {
        // ignore load error; fallback to static options
      }
    })();
  }, []);

  const onSave = async () => {
    setSaving(true);
    setError(null);
    try {
      const selectedPlanName = plans.find((p) => p.id === form.subscriptionPlanId)?.name;
      const resp = await superAdminApi.createTenant({ ...form, plan: selectedPlanName || form.plan, subscriptionPlanId: form.subscriptionPlanId });
      if (resp.success) navigate('/super-admin/tenants');
      else setError(resp.message || 'Error al crear tenant');
    } catch (e: any) {
      setError(e?.response?.data?.message || 'Error al crear tenant');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>Crear Tenant</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Paper sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Nombre" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Subdominio" value={form.subdomain} onChange={(e) => setForm({ ...form, subdomain: e.target.value })} helperText="Sin espacios. Ej: cliente1" />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              select
              fullWidth
              label="Plan"
              value={plans.length ? (form.subscriptionPlanId ?? '') : form.plan}
              onChange={(e) => {
                if (plans.length) {
                  const planId = Number(e.target.value);
                  const planName = plans.find((p) => p.id === planId)?.name || form.plan;
                  setForm({ ...form, subscriptionPlanId: planId, plan: planName });
                } else {
                  setForm({ ...form, plan: e.target.value, subscriptionPlanId: undefined });
                }
              }}
            >
              {(plans.length ? plans.map((p) => ({ value: p.id, label: p.name })) : ['Starter', 'Growth', 'Scale', 'Enterprise'].map((p) => ({ value: p, label: p }))).map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField fullWidth label="Admin Nombre" value={form.adminName} onChange={(e) => setForm({ ...form, adminName: e.target.value })} />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField fullWidth label="Admin Email" value={form.adminEmail} onChange={(e) => setForm({ ...form, adminEmail: e.target.value })} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Admin Password" type="password" value={form.adminPassword} onChange={(e) => setForm({ ...form, adminPassword: e.target.value })} />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
              <Button variant="outlined" onClick={() => navigate('/super-admin/tenants')}>Cancelar</Button>
              <Button variant="contained" onClick={onSave} disabled={saving}>{saving ? 'Creando...' : 'Crear'}</Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};
